import { useEffect } from 'react';

const GlobalDragDropListener = () => {
    const noDragDropElements = ['input', 'textarea'];
    const handleDragStart = (e) => {
        if (e.target.tagName && noDragDropElements.some(i => i === e.target.tagName.toLowerCase())) {
            e.preventDefault();
        }
    };

    const handleDocumentDrop = (e) => {
        if (e.target.tagName && noDragDropElements.some(i => i === e.target.tagName.toLowerCase())) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        document.addEventListener('dragstart', handleDragStart);
        document.addEventListener('drop', handleDocumentDrop);

        return () => {
            document.removeEventListener('dragstart', handleDragStart);
            document.removeEventListener('drop', handleDocumentDrop);
        };
    }, []);

    return null;
}
GlobalDragDropListener.propTypes = {
};

export default GlobalDragDropListener;